import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { WordBalloon } from "./WordBalloon";

const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const SKIP = new Set(["code", "inlineCode", "link"]);

const remarkHardWords = (words) => () => (tree) => {
  const alt = [...words].sort((a, b) => b.length - a.length).map(escape).join("|");
  const regex = new RegExp(`\\b(${alt})\\b`, "gi");
  const exact = new RegExp(`^(${alt})$`, "i");
  const used = new Set();
  const visit = (node) => {
    if (!node.children) return;
    node.children = node.children.flatMap((child) => {
      if (child.type !== "text") {
        if (!SKIP.has(child.type)) visit(child);
        return [child];
      }
      return child.value.split(regex).filter(Boolean).map((part) => {
        if (!exact.test(part) || used.has(part.toLowerCase())) return { type: "text", value: part };
        used.add(part.toLowerCase());
        return { type: "hardWord", data: { hName: "span", hProperties: { className: ["hard-word-src"] } }, children: [{ type: "text", value: part }] };
      });
    });
  };
  visit(tree);
};

export const Markdown = ({ children, testid, words }) => {
  const text = children || "";
  const hasWords = words?.length > 0;
  const plugins = hasWords ? [remarkGfm, remarkHardWords(words)] : [remarkGfm];
  const components = hasWords
    ? {
        span: ({ node, className, children: c, ...props }) =>
          className?.includes("hard-word-src")
            ? <WordBalloon word={String(c)} context={text} />
            : <span className={className} {...props}>{c}</span>,
      }
    : undefined;
  return (
    <div className="what-md" data-testid={testid}>
      <ReactMarkdown remarkPlugins={plugins} components={components}>{text}</ReactMarkdown>
    </div>
  );
};
